$(document).ready(function () {
	if (!$('#main-article-responsive')[0]) {
		//console.log("not an article")
		return false;
	}
	setPageLoad();
	setTimeout(articleToggles, 1500);
	initHeaderMore();
	initSocialMediaLinks();
    initSocialMediaImage();
	copyToClipboard();
	initWebView();
	headerReplace();
	lengthOfArticle();
	intBarLengthOfArticle();
	initTableOfContents();
	initializeAuthorToolTip();
	goToSource();
});

function setPageLoad(){
	if ($("#RBCN6_header .menuContainer nav#rbcn6menu").length > 0) {
		$('header,#side-menu-id').remove();
	} else {
		$('#RBCN6_header').remove();
	}
}

function initHeaderMore(){
	$('#header-more').click(function(e){
		if ($('#series-hidden').is(":visible")){
			$('#header-more').removeClass('active');
            $(this).attr('aria-expanded','false');
            $('#series-hidden').addClass('d-none');
			$(this).parent('li').removeClass('active');
		} else {
			$('#header-more').addClass('active');
            $(this).attr('aria-expanded','true');
            $('#series-hidden').removeClass('d-none');
			$(this).parent('li').addClass('active');
			e.stopPropagation();
		}
		
	});
	
	/*
	$(document).on('keyup', function(e) {
        if(e.key == "Enter") {
			if ($('#series-hidden').is(":visible")){
				$('#header-more').removeClass('active');
				$('#series-hidden').addClass('d-none');
			} else {
				$('#header-more').addClass('active');
				$('#series-hidden').removeClass('d-none');
			}
        }
    });
	*/
	
	$(document).on('keyup', function(e) {
		if (e.key === "Escape") {
			$('#header-more').removeClass('active');
			$('#series-hidden').addClass('d-none');
			$('#header-more').parent('li').removeClass('active');
		}
	});
	
	$(document).on('click', function(event) {
		// Check if the clicked target is NOT the element itself,
		// and NOT a descendant of the element,
		// and NOT the toggle button (if applicable)
		if ($('#series-hidden').is(":visible")){
			if (!$(event.target).closest('#series-hidden').length) {
				$('#header-more').removeClass('active');
				$('#series-hidden').addClass('d-none');
				$('#header-more').parent('li').removeClass('active');
			}
		}
	});
}

function initWebView(){
	//if users are viewing Inspired Investor articles in Android webview
	if (navigator.userAgent.includes("wv") || navigator.userAgent.includes("WebView")){
		$('head').append('<link rel="stylesheet" href="/assets/di-secure/common/css/webview.css">');
		$('head').append('<script type="text/javascript" src="/assets/di-secure/common/js/webview.js"></script>');
	}
	
	//if users are viewing Inspired Investor articles in IOS webview
	if (navigator.userAgent.includes("wAppleWebKit") && !navigator.userAgent.includes("Safari")){
		$('head').append('<link rel="stylesheet" href="/assets/di-secure/common/css/webview.css">');
		$('head').append('<script type="text/javascript" src="/assets/di-secure/common/js/webview.js"></script>');
	}
}

function initSocialMediaLinks() {
    var el = $('.social-media-links a');
    if (!el.length) return;
    el.each(function () {
        var curr = $(this);
        var href = '';
        var new_href = '';
        href = curr.attr('href');
        href = href + location.href;
        if (href.indexOf('www6.steroyalbank') != -1) {
            new_href = '';
            new_href = href.replace('https://www6.steroyalbank.com/', 'https://inspiredinvestor.sterbcdirectinvesting.com/');
            curr.attr('href', new_href);
        } else if (href.indexOf('www6.royalbank') != -1) {
            new_href = '';
            new_href = href.replace('https://www6.royalbank.com/', 'https://inspiredinvestor.rbcdirectinvesting.com/');
            curr.attr('href', new_href);
        } else {
            curr.attr('href', href);
        }
        //href = href + 'https://www6.royalbank.com/en/di/hubs/food/article/are-etfs-the-craft-beer-of-modern-investing/jeoz839m';

    });
}

function initSocialMediaImage() {
    if ($('#hero-banner').length > 0) {
        var articleImage = $('#hero-banner').find('img')[0];
        if (articleImage != null) {
            articleImage = $('#hero-banner').find('img')[0].src;
            $("head").append("<meta property='og:image' content='" + articleImage + "'/>");
        }
    }
}

function copyToClipboard(){
	$(document).ready(function() {
	  $('#copy-link').on('click', function() {
		var urlToCopy = window.location.href;

		if (navigator.clipboard && navigator.clipboard.writeText) {
		  navigator.clipboard.writeText(urlToCopy)
			.then(function() {
			  console.log('URL copied to clipboard!');
			})
			.catch(function(err) {
			  console.error('Failed to copy URL: ', err);
			});
		} else {
		  // Fallback for older browsers
		  copyToClipboardLegacy(urlToCopy);
		}
	  });
	});
}

function headerReplace(){
	//this function replaces <p><strong> tags with <h2> tags
	//var headingText="";
	$(".article-content p").each(function() {
        var html = $(this).html().trim();
        //console.log(html);
        // Check if the only content is a single <strong> tag
        if (/^<strong>.*<\/strong>$/.test(html)) {
            //console.log(headingText=$(this).html());
            var strongContent = $(this).find("strong").html();
            $(this).replaceWith('<h2>'+strongContent+'</h2>');
        }
    });
}

function initTableOfContents(){
	$('#toc-content').append('<ul>');
	var headerText = "";
	var idText = "";
	$('.inner-wrapper > .row .article-content h2').each(function(){
		headerText = $(this).text();		
		idText = headerText.replace(/[^a-zA-Z0-9]+/g, '-');
		$(this).attr('id',idText);
		if($(this).parents('div').hasClass('show-mobile')){
			$('#toc-content ul').append('<li class="fw-normal mb-30px d-block d-md-none"><a href="#'+idText+'">'+headerText+'</a></li>');
		} else if($(this).parents('div').hasClass('show-desktop')) {
			$('#toc-content ul').append('<li class="fw-normal mb-30px d-none d-md-block"><a href="#'+idText+'">'+headerText+'</a></li>');
		} else {
			$('#toc-content ul').append('<li class="fw-normal mb-30px"><a href="#'+idText+'">'+headerText+'</a></li>');
		}
	});
}

function lengthOfArticle(){
	var bodyText=$("#article-body .row .col-12 .article-content").text();
	//console.log(bodyText);
	var words = bodyText.trim().split(/\s+/).length;
	var wpm = 200;
	var time = Math.ceil(words / wpm);
	
	$('#article-length').text(time);	
}

function intBarLengthOfArticle(){
	$('#interupter-bar > ul > li > a').each(function(data){
		var currElement = $(this);
		$.ajax({
		  url: currElement.attr('href'),
		  method: 'GET',
		  dataType: 'html',
		  success: function(data) {
			var bodyText=$(data).find("#article-body .row .col-12 .article-content").text();
			//console.log(bodyText);
			var words = bodyText.trim().split(/\s+/).length;
			var wpm = 200;
			var time = Math.ceil(words / wpm);
			currElement.find('.int-bar-article-time').text(time);
		  },
		  error: function(jqXHR, textStatus, errorThrown) {
			currElement.find('.int-bar-article-time').remove();
			console.error('Request failed:', textStatus, errorThrown);
		  }
		});
	});	
}

function articleToggles(){
	if((localizedURL != "undefined") && (localizedURL != null) && (localizedURL != '')){
		if(window.location.pathname.indexOf('/en/di/hubs/') != -1){
			$('.lang-en').attr('href',window.location.pathname);
			$('.lang-fr').attr('href',localizedURL);
		}else{
			$('.lang-en').attr('href',localizedURL);
			$('.lang-fr').attr('href',window.location.pathname);
		}
		console.log('localized url present');
	} else {
		if(window.location.pathname.indexOf('/en/di/hubs/') != -1){
			$('.lang-en').attr('href',window.location.pathname);
			$('.lang-fr').attr('href','/learn/fr/di/hubs/inspired-investor/index');
		} else {
			$('.lang-en').attr('href','/learn/en/di/hubs/inspired-investor/index');
			$('.lang-fr').attr('href',window.location.pathname);
		}
		console.log('localied url not present');
	}
}

function popOverStyles(){
	var openPopover = "";
	var closePopover = "";
	if($('html').attr('lang') == 'fr'){
		openPopover = "Cliquez pour ouvrir la biographie de l'auteur";
		closePopover = 'Fermer';
	} else {
		openPopover = "Click to open author bio";
		closePopover = 'Close';
	}
	$('.popover-body .btn-close').remove();
	$('.popover-body').addClass('d-flex');
	$('.popover-body').css('flex-direction','row-reverse');
	$('.popover-body').prepend('<button type="button" class="btn-close ms-16px" aria-label="'+closePopover+'"></button>');
	$('.popover-body .btn-close').focus();
	$('.btn-close').on('click',function(){
		$('.popover').popover('hide');
		$('#author-bio').removeClass('open');
		$('#author-bio').attr('aria-label',openPopover);
		$('#author-bio img').attr('src','/assets/di-secure/common/images/tooltip.svg');
	});
	$(".popover-body .btn-close").focusout(function() {
	  // Code to execute when the input loses focus
	  //$('.popover').popover('hide');
	  $('#author-bio').focus();
	});
}

function initializeAuthorToolTip(){
	var openPopover = "";
	var closePopover = "";
	var popoverTriggerList = [].slice.call(document.querySelectorAll('[data-bs-toggle="popover"]'))
	var popoverList = popoverTriggerList.map(function (popoverTriggerEl) {
	  return new bootstrap.Popover(popoverTriggerEl)
	})
	
	if($('html').attr('lang') == 'fr'){
		openPopover = "Cliquez pour ouvrir la biographie de l'auteur";
		closePopover = "Cliquez pour fermer la biographie de l'auteur";
	} else {
		openPopover = "Click to open author bio";
		closePopover = "Click to close author bio";
	}
	
	$('#author-bio').unbind().on('click',function(){
		if($(this).hasClass('open')){
			$('#author-bio').attr('aria-label',openPopover);
			$('#author-bio img').attr('src','/assets/di-secure/common/images/tooltip.svg');
			$('#author-bio img').attr('alt','');
			$(this).removeClass('open');
			$(this).popover('hide');
			
		} else {
			$('#author-bio').attr('aria-label',closePopover);
			$('#author-bio img').attr('src','/assets/di-secure/common/images/tooltip-active.svg');
			$('#author-bio img').attr('alt','');
			$(this).addClass('open');
			$(this).popover('show');
			popOverStyles();
		}
	});
	/*
	$('#author-bio').unbind().on('keydown', function(e) {
		if (e.key === 'Enter') {
			if($(this).hasClass('open')){
				$('#author-bio img').attr('src','/assets/di-secure/common/images/tooltip.svg');
				$('#author-bio img').attr('alt','');
				$(this).removeClass('open');
				$(this).popover('hide');
			} else {			
				$('#author-bio img').attr('src','/assets/di-secure/common/images/tooltip-active.svg');
				$('#author-bio img').attr('alt','');
				$(this).addClass('open');
				$(this).popover('show');
				popOverStyles();
			}
		}
	});
	*/
		
}

function goToSource(){
	$("a[href='#source-collapse']").addClass('go-to-source');
	$('a.go-to-source').on('click', function(e) {
		e.preventDefault();
		var collapse = new bootstrap.Collapse($('#source-collapse')[0], { toggle: false });
		collapse.show();
        var source = $(this).text();
		$('#sources-'+source).focus();
	});
}